export interface AuthState {
  id_user: number | null;
  nombre: string | null;
  usuario: string | null;
  correo: string | null;
  celular: string | null;
  password: string | null;
  id_rol: number | null;
  img: string | null;
  created: string | null;
}

export const initialAuthState: AuthState = {
  id_user: null,
  nombre: null,
  usuario: null,
  correo: null,
  celular: null,
  password: null,
  id_rol: null,
  img: null,
  created: null
};